
$(document).ready(function() {
 // Validation logic on polling module.  If no radio buttons are selected displays message.		
    $(document).on('click', '.pollVote', function (event) {
        event.preventDefault();
        var parentForm = $(this).closest('form');
        if (!$(parentForm).find("input[type='radio']").is(":checked")) {
            $(parentForm).addClass('error');
        } else {
            $(parentForm).submit();
        }

    });

    $(document).on('change', '.pollForm input[type="radio"]',function () {
        $(this).closest('form').removeClass('error');
    });
   

    var totVotes = 0;
    var totPercent = 0;
    $('.percentBar').each(function() {
        var percent = (parseFloat(jQuery(this).html())) / 100;
        if (isNaN(percent))
            percent = 0;
        jQuery(this).width(jQuery(this).parent().width() * percent);
        totPercent += parseFloat(jQuery(this).html());
    });
    $('.numVotes').each(function() {
        tmp = parseInt(jQuery(this).html());
        if (isNaN(tmp))
            tmp = 0;
        totVotes += tmp;
    });
    $('#totVotes').html(totVotes);
    $('#totPercent').html(Math.round(totPercent));

});
